<ng-container *transloco="let t; read: 'partials.content_container'">
  <div *ngIf="element !== null" class="element-container" (contextmenu)="onRightClick($event)" onCut="return false" onCopy="return false">
    <div class="element-chapters">
      <p class="topline">{{ t('toc') }}</p>
      <ul role="menu">
        <app-content-nav-chapter *ngFor="let chapter of element.content" [chapter]="chapter" [active]="activeChapter" (clicked)="showChapter($event)"></app-content-nav-chapter>
      </ul>
    </div>
    <div class="element-content" (mouseup)="onMouseUp($event)">
      <div id="markers" aria-hidden="true">
        <div *ngFor="let mark of marks" [hidden]="showMarks !== true">
          <div *ngFor="let layer of mark.layers" (click)="showCommentDialog(mark)"
            class="layer"
            [style.top]="layer.top"
            [style.left]="layer.left"
            [style.width]="layer.width"
            [style.height]="layer.height"
            [style.backgroundColor]="layer.color"
            [pTooltip]="layer.notices"
            tooltipPosition="top"
          ></div>
        </div>
      </div>
      <div id="container" role="article" aria-live="polite">
        <div id="content" [innerHtml]="content | byPassSecurity"></div>
      </div>
      <button [style.top]="markerPos.top" [style.left]="markerPos.left" #comment pButton type="button" class="p-button-secondary p-button-raised p-button-rounded comment-button" icon="pi pi-comment" (click)="showCommentDialog()" aria-hidden="true"></button>
    </div>
  </div>
  <p-dialog [(visible)]="dialogVisible" [draggable]="false" [resizable]="false" [modal]="true" [closable]="false">
    <p-header>
      <span *ngIf="dialogMode === 'new'">{{ t('add_comment') }}</span>
      <span *ngIf="dialogMode === 'edit'">{{ t('delete_comment') }}</span>
    </p-header>
    <div *ngIf="activeMark !== null" class="comment-dialog">
      <label>Farbe</label>
      <ul class="color-picker">
        <li *ngFor="let color of markerColors">
          <span [attr.style]="'background-color: ' + color + ';'" (click)="setActiveColor(color)">
            <fa-icon *ngIf="color == activeMark.color" [icon]="faCheck"></fa-icon>
          </span>
        </li>
      </ul>
      <label class="p-mt-4">{{ t('comment') }}</label>
      <textarea class="p-mb-4" pInputTextarea [(ngModel)]="activeMark.notices"></textarea>
      <p-footer>
        <div class="p-grid">
          <div class="p-col" *ngIf="dialogMode === 'edit'">
            <button (click)="deleteMark()" pButton type="button" icon="pi pi-trash" class="p-button-outlined danger-button"></button>
          </div>
          <div class="p-col p-text-right">
            <button (click)="hideCommentDialog()" pButton type="button" label="{{ t('labels.cancel') }}" class="p-button-outlined p-mr-2"></button>
            <button (click)="saveComment()" pButton type="button" label="{{ t('labels.ok') }}" [disabled]="!isValid()"></button>
          </div>
        </div>
      </p-footer>
    </div>
  </p-dialog>
</ng-container>
